<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ pageTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">发布邀请书列表</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-plus" @click="handleAddNew">新增邀请书</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column type="index" label="NO." width="60" align="center" :index="indexMethod" />
                <el-table-column prop="bidInviteName" label="邀请书名称" show-overflow-tooltip />
                <el-table-column prop="bidInviteCode" label="邀请书编码" show-overflow-tooltip />
                <el-table-column prop="bidInviteIssueTime" label="发布时间" width="180" align="center" />
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <span>{{ getStatusText(scope.row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetail(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button 
                            v-if="[0, 2].includes(scope.row.status)" 
                            type="text" 
                            size="small" 
                            @click="handleEdit(scope.row)" 
                            class="action-btn">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>
    </div>
</template>

<script>
import { getProjectDetail } from '@/api/modules/agent'
import { getProjectTypeName } from '@/utils/base'
import { invitationLetterList, invitationLetterDetail } from '@/api/modules/invitationLetter'

export default {
    name: 'PublishTenderAnnouncement',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectId: this.$route.query.projectId,
            projectDetail: {},
            pageTitle: '',
            loading: false,
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    mounted() {
        this.loadProjectDetail()
        this.getInvitationLetterList()
    },
    methods: {
        /**
         * 加载项目详情
         */
        async loadProjectDetail() {
            const res = await getProjectDetail({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.projectDetail = res.data
                this.pageTitle = this.generatePageTitle(res.data)
            } else {
                this.$message.error('获取项目详情失败')
            }
        },
        //生成页面标题
        generatePageTitle(projectData) {
            const projectTypeName = getProjectTypeName(projectData.projectType)
            return `${projectTypeName}--招标项目编号：${projectData.projectCode}　招标项目名称：${projectData.projectName}`
        },
        //投标邀请书列表
        getInvitationLetterList() {
            this.loading = true
            const params = {
                projectCode: this.projectCode,
                current: this.pagination.currentPage,
                size: this.pagination.pageSize
            }
            invitationLetterList(params).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                } else {
                    this.$message.error(res.message || '获取邀请书列表失败')
                }
            }).catch(error => {
                console.error('获取邀请书列表失败:', error)
                this.$message.error('获取邀请书列表失败')
            }).finally(() => {
                this.loading = false
            })
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 新增邀请书
        handleAddNew() {
            this.$router.push({ path: '/agentHome/singleSourceCreate', query: { type: 'new_change', projectCode: this.projectCode } })
        },
        // 查看详情 - 跳转到详情页面（只读）
        handleViewDetail(row) {
            this.$router.push({ path: '/agentHome/singleSourceCreate', query: { type: 'detail', projectCode: this.projectCode, bidInviteCode: row.bidInviteCode } })
        },
        // 编辑 - 跳转到编辑页面
        handleEdit(row) {
            this.$router.push({ path: '/agentHome/singleSourceCreate', query: { type: 'edit', projectCode: this.projectCode, bidInviteCode: row.bidInviteCode } })
        },


        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },

        // 加载数据
        loadData() {
            this.getInvitationLetterList()
        },

        // 序号计算
        indexMethod(index) {
            return (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1
        },

        // 状态文本转换
        getStatusText(status) {
            const statusMap = {
                0: '暂存',
                1: '已提交',
                2: '退回',
                9: '已发布'
            }
            return statusMap[status] || '-'
        }
    },

}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部优化（带按钮组）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

.table-section {
    background: #fff;
    border-radius: 4px;
    box-shadow: @shadow-sm;
    padding: 20px;
}

.data-table {
    /deep/ .el-table__header-wrapper {
        th {
            background-color: @gray-100;
            color: @gray-700;
            font-weight: 600;
        }
    }

    .action-btn {
        color: @primary-color;
        margin-right: 10px;

        &:hover {
            color: @primary-hover;
        }
    }
}

.pagination-section {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    background: #fff;
    border-radius: 4px;
    padding: 15px 20px;
    box-shadow: @shadow-sm;
}
</style>
